import React from "react";
import StickyHeadline from "./StickyHeadline";
import ServiceMenu from "./ServiceMenu";
import { HighlightedQuote, Section, ContentBlock } from "./ui";
import BrandStoryHighlight from "./BrandStoryHighlight";

const HeroMenu = ({
  stickyHeadline,
  subtitle,
  highlight,
  links = [],
  navbarHeight = 0,
  className = "",
}) => {
  return (
    <div
      className={`relative ${className} bg-[var(--color-secondary-dark)] sm:pt-[8px] `}
    >
      {/* Sticky Headline */}
      {stickyHeadline && (
        <StickyHeadline
          headline={stickyHeadline}
          subtitle={subtitle}
          navbarHeight={navbarHeight}
          className="pt-8 sm:pt-0"
        />
      )}

      {/* Service Menu - positioned right under the sticky headline */}
      <ServiceMenu
        navbarHeight={navbarHeight + 40} // Account for sticky headline height
        links={links}
      />

      <BrandStoryHighlight
        mainText="DIE ZUKUNFT IST LEISE"
        subText="unsere Arbeit nicht."
      />
      {/* Highlight Section - styled like TextSectionHero */}
      {/* {highlight && (
        <Section variant="secondary" spacing="comfortable" margin={false}>
          <ContentBlock maxWidth="4xl" align="left" className="mx-auto">
            <HighlightedQuote
              variant="lead"
              color="primary"
              noSpacing
              dangerouslySetInnerHTML={
                typeof highlight === "string"
                  ? { __html: highlight }
                  : undefined
              }
            >
              {typeof highlight === "string" ? undefined : highlight}
            </HighlightedQuote>
          </ContentBlock>
        </Section>
      )} */}
    </div>
  );
};

export default HeroMenu;
